import { Tooltip } from "@mui/material"
import { ReactComponent as Info } from "assets/Info.svg"
import Typography from "components/common/Typography"
import { useTranslate } from "hooks/useTranslate"
import { tokens } from "styles/Tokens"
import "./index.scss"

export const SummaryTooltip = ({ item }: { item: any }) => {
    const translate = useTranslate();

    return (
        <div className="summary-tooltip">
            <Typography
                className="action-name"
                variant="body2"
                color={tokens.Text.General.PrimaryHeadline}
            >
                {item.name}
            </Typography>
            <div>
                <Tooltip title={item.summary || translate("common.noSummary")} >
                    <Info />
                </Tooltip >
            </div>
        </div>
    )
}